// Returns any error messages associated with given password
function password(password, username) {

    var errors = [];

    // min length 8, max 128
    if(password.length < 8)
        errors.push('Password must be at least 8 characters.');

    // max length 128
    if(password.length > 128)
        errors.push('Password cannot exceed 128 characters.');

    // password cannot contain username
    if(password.includes(username))
        errors.push('Password cannot contain username.');

    return errors;
}

// Returns any error messages associated with given username
function username(username) {

    var errors = [];

    // min length 6
    if(username.length < 6)
        errors.push('Username must be at least 6 characters.');

    // max length 32
    if(username.length > 32)
        errors.push('Username cannot exceed 32 characters.');

    // no spaces
    const hasSpaces = /[\s]/;
    if(hasSpaces.test(username))
        errors.push('Username cannot contain spaces.');

    // no special chars except '-', '_', '.'
    const hasSpecialChars = /[^A-Za-z0-9_\-\.]/;
    if(hasSpecialChars.test(username)) 
        errors.push("Username can only contain numbers, letters and '-', '_', '.'");

    return errors;
    
}

// Returns any error messages associated with given email address
function email(email) {

    var errors = [];

    var validEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

     if(!validEmail.test(email))
        errors.push('Email appears to be invalid.');

    return errors;

}

const Validate = { password, username, email };
export default Validate;


// WEBPACK FOOTER //
// ./src/Utils/Validate.js